// These transport types are mapped as they are in the BE
export const TransportTypes = {
    MARITIME: 1,
    RAIL: 2,
    ROAD: 3,
    AIR: 4,
    MAIL: 5,
    FIXED_TRANSPORT_INSTALLATIONS: 7,
    INLAND_WATERWAY_TRANSPORT: 8,
    OWN_PROPULSION: 9,
} as const;

export type TransportType = typeof TransportTypes[keyof typeof TransportTypes];

export const TransportTypeLabels: Record<TransportType, string> = {
    [TransportTypes.MARITIME]: 'Sea/Maritime transport',
    [TransportTypes.RAIL]: 'Rail transport',
    [TransportTypes.ROAD]: 'Road transport',
    [TransportTypes.AIR]: 'Air transport',
    [TransportTypes.MAIL]: 'Mail',
    [TransportTypes.FIXED_TRANSPORT_INSTALLATIONS]: 'Fixed transport installations',
    [TransportTypes.INLAND_WATERWAY_TRANSPORT]: 'Inland waterway transport',
    [TransportTypes.OWN_PROPULSION]: 'Own propulsion',
};

export const TransportTypeOptions: ReadonlyArray<{ id: TransportType; value: string }> = (
    Object.keys(TransportTypeLabels) as unknown as TransportType[]
)
    .map((k) => ({
        id: k,
        value: TransportTypeLabels[k],
    }))
    .sort((a, b) => a.id - b.id);

export const getTransportTypeLabel = (id: number | null | undefined): string | undefined =>
    isTransportType(id) ? TransportTypeLabels[id] : undefined;

export const transportTypeValues = Object.values(TransportTypes) as TransportType[];

export const isTransportType = (v: unknown): v is TransportType =>
    typeof v === 'number' && (transportTypeValues as number[]).includes(v as number);

export const getTransportTypeDisplay = (id: number | string | null | undefined): string => {
    if (id == null || id === '') return '';
    const num = typeof id === 'string' ? Number(id) : id;
    const label = getTransportTypeLabel(num);
    return label ? `${num} - ${label}` : String(num);
};
